import './recentExpenses.css';
import { useState, useEffect } from 'react';

import CategoryIcons from '../../../assets/categoryIcons/categoryIcons';
import BulletPoint from '../../../assets/bulletPoint/bulletPoint';
import SpacerBar from '../../spacerBar/spacerBar';
import VerticalBar from '../../verticalBar/verticalBar';
import SearchIcon from '../../../assets/icons/searchIcon/searchIcon';

export default function RecentExpenses({loading, expenses, filteredExpenses}) {

    const [recentTransactions, setRecentTransactions] = useState([{'expense_name': 'no-access'}]);

    const [search, setSearch] = useState({query: ''});

    useEffect(() => {

        const sortTransactions = () => {
            setRecentTransactions(filteredExpenses[1].sort((a, b) => new Date(b.date) - new Date(a.date)))
        };

        sortTransactions();

}, [filteredExpenses]);

    const handleSearch = (e) => {
        const { name, value } = e.target;
        setSearch((prev) => ({
            ...prev,
            [name]: value
        }));

        console.log(e.target.value)

        const displayedTransactions = (filteredExpenses[1].sort((a, b) => new Date(b.date) - new Date(a.date))).filter(item => {
        const name = item.expense_name || "";
        const queryText = e.target.value || ""; 
        return name.toLowerCase().startsWith(queryText.toLowerCase());
    });
        setRecentTransactions(displayedTransactions)

    }


    if (loading) {
        return (
            <div>Loading...</div>
        )
    }
//console.log(expenses)

    return (
        <div className="recent-expenses-container">
            <div className="recent-expenses-header">
                <p>Recent Expenses:</p>
                <div className="search-bar"><SearchIcon/><input className="recent-expenses-search" type="text" placeholder="Search Recent Expenses:" name="query" value={search.query} onChange={handleSearch}></input></div>
            </div>
            <div className="recent-expenses-list scroll-container">
            {
            recentTransactions?.map((item, index) => {
                return(
                <div key={index}>
                    <div key={index} className="recent-expenses-list-item-container">
                        {/*<BulletPoint/>*/}
                        <CategoryIcons indexIcon={item.expense_svg_icon} expenseColor={item.expense_svg_color} className=''/>
                        <p>{item.expense_name}</p>
                        <VerticalBar height='4vh'/>
                        <p><strong>${item.expense_amount}</strong></p>
                        <VerticalBar height='4vh'/>
                        <p>{new Date(item.expense_date).toLocaleDateString()}</p>
                        
                    </div>
                    <SpacerBar width='95%' center='auto'/>
                </div>
            )})}
            </div>
        </div>
    )
}